import { useState } from 'react';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import ParallaxSection from './components/ParallaxSection';
import SystemSection from './components/SystemSection';
import FloorGallery from './components/FloorGallery';
import AccessSection from './components/AccessSection';
import ContactSection from './components/ContactSection';
import FooterBanner from './components/FooterBanner';
import Footer from './components/Footer';
import AffiliateModal from './components/AffiliateModal';

export default function HomePage() {
  const [affiliateOpen, setAffiliateOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Header />
      <main>
        <HeroSlider />
        <SystemSection />
        <ParallaxSection />
        <FloorGallery />
        <AccessSection />
        <ContactSection />
      </main>
      <FooterBanner
        onOpenAffiliate={() => setAffiliateOpen(true)}
      />
      <Footer />

      {affiliateOpen && <AffiliateModal onClose={() => setAffiliateOpen(false)} />}
    </div>
  );
}
